export const defaultState = () => ({
  timetable: [],
  school: undefined,
  slink: undefined,
  authToken: undefined,
  stayLoggedIn: undefined,
  headerDisabled: false,
  transitionName: '',
  isScreenReaderActive: false,
  isKeyboardNavigationActive: false,
  softKeyboardHeight: 0,
  isNative: false,
  isAndroid: false,
  isIOS: false,
})

export default defaultState()
